<template>
  <div class="mdrawer">
    <el-row :gutter="20" class="mstyle_first">
      <el-col :span="2" class="m-th">合同名称</el-col>
      <el-col :span="10" class="m-td">{{ singleContract.flow_name }}</el-col>
      <el-col :span="2" class="m-th">发起方</el-col>
      <el-col :span="10" class="m-td border-right-style">{{ singleContract.tx_company.organization_name }}</el-col>
    </el-row>
    <el-row :gutter="20" class="mstyle_s">
      <el-col :span="2" class="m-th">发起人</el-col>
      <el-col :span="10" class="m-td">{{ singleContract.admin_user.username }}</el-col>
      <el-col :span="2" class="m-th">签署方</el-col>
      <el-col :span="10" class="m-td border-right-style">
        <template>
          <div v-for="(item, index) in singleContract.approvers" :key="index">
            <span class="hide-style">{{ getOrganizationName(singleContract.tx_company.organization_name, item, singleContract.company) }}</span>
          </div>
        </template>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mstyle_first">
      <el-col :span="2" class="m-th">合同状态</el-col>
      <el-col :span="10" class="m-td">{{ singleContract.flow_status }}</el-col>
      <el-col :span="2" class="m-th">合同类型</el-col>
      <el-col :span="10" class="m-td border-right-style">{{ singleContract.flow_type }}</el-col>
    </el-row>
    <el-row :gutter="20" class="mstyle_s lbottom">
      <el-col :span="2" class="m-th">发起时间</el-col>
      <el-col :span="10" class="m-td">{{ singleContract.created_at }}</el-col>
      <el-col :span="2" class="m-th">过期时间</el-col>
      <el-col :span="10" class="m-td border-right-style">{{ singleContract.dead_line }}</el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'ContractDetail',
  props: { singleContract: Object },
  data () {
    return {

    }
  },
  watch: {
  },
  methods: {
    getOrganizationName (txName, item, company) {
      let str = ''
      if ((item.ApproverType === 0 || item.ApproverType === 3) && item.OrganizationName !== txName) {
        str = company ? company.company_name + '_' + item.ApproverName : item.OrganizationName + '_' + item.ApproverName
      } else if (item.ApproverType === 1) {
        str = item.ApproverName
      }
      return str
    }
  }
}
</script>
<style scoped>
.mstyle_first {
  border: 1px solid #ccc;
  border-bottom: none;
}

.mstyle_first>* {
  border-right: 1px solid #ccc;
  white-space: nowrap;
}

/* .mstyle_first :nth-child(odd) {
  background-color: #f0f9eb;
} */
/* .mstyle_first :nth-child(even) {
  background-color: oldlace;
} */
.mstyle_s {
  border: 1px solid #ccc;
  border-bottom: none;
}

.mstyle_s>* {
  border-right: 1px solid #ccc;
  white-space: nowrap;
}

/* .mstyle_s :nth-child(odd) {
  background-color: #f0f9eb;
} */
/* .mstyle_s :nth-child(even) {
  background-color: oldlace;
} */
.lbottom {
  border-bottom: 1px solid #ccc;
}

.m-th {
  height: 42px;
  line-height: 42px;
  padding: 0 5px;
  color: #909399;
  background: #fafafa;
}

.m-td {
  height: 42px;
  line-height: 42px;
  padding: 0 5px;
}

.border-right-style{
  border-right: none;
}
</style>



// WEBPACK FOOTER //
// src/common/ContractDetail.vue